import { Link, Typography } from '@mui/joy'
import { Link as RouterLink } from 'react-router-dom'
import routes from 'routes'
import UserTooltip from 'components/UI/UserTooltip'
import Salary from 'components/UI/Salary'
import UserResultDownloadTooltip from 'components/UI/UserResultDownloadTooltip'
import AdvancedTooltip from 'components/UI/AdvancedTooltip'

const commonLp = {
  sortableBy: 'lp',
  sortableSide: 'right',
  label: 'Nr',
  propName: 'lp',
  className: 'width-xs',
}

const commonStatus = {
  sortableBy: 'computedStatusSorter',
  sortableSide: 'left',
  label: 'Status',
  propName: 'assignment2',
  type: 'assigmentModeAdmin',
  rowClassName: 'text-center',
  className: 'text-center',
}

const commonSalary = {
  sortableBy: 'computedSalary',
  sortableSide: 'left',
  label: 'Wynagrodzenie brutto',
  type: 'computed',
  propName: 'computedSalary',
  rowClassName: 'text-center',
  className: 'text-center width-xxl',
  fn: (task) => <Salary task={task} />,
}

const commonAssignmentUser = {
  sortableBy: 'computedAssignmentFullName',
  sortableSide: 'left',
  label: 'Pracownik',
  propName: 'assignment',
  rowClassName: 'text-center',
  className: 'text-center width-xl',
  type: 'computed',
  fn: (task) => {
    const user = task.assignment
    if (!user) return <Typography level="body-xs">–</Typography>
    return (
      <UserTooltip user={user}>
        <Link component={RouterLink} to={routes.adminUsersDetails.replace(':userId', user.userId)} level="title-sm">
          <Typography color="primary" level="body-xs">
            {user.firstName} {user.lastName}
            {task.reserveList && (
              <Typography color="warning" level="body-xs">
                &nbsp;+{task.reserveList.length}
              </Typography>
            )}
          </Typography>
        </Link>
      </UserTooltip>
    )
  },
}

export const getAdminTasksHeaders = (project) => {
  let headers = [commonLp]

  if ([1, 3].includes(project.type))
    headers.push(
      {
        sortableBy: 'date',
        sortableSide: 'right',
        label: 'Data',
        propName: 'date',
        type: 'date',
        rowClassName: 'text-center',
        className: 'text-center width-sm',
      },
      { label: 'Godziny', propName: 'hours', rowClassName: 'text-center', className: 'text-center' },
      {
        sortableBy: 'hoursCount',
        sortableSide: 'right',
        label: 'Ilość godzin',
        propName: 'hoursCount',
        rowClassName: 'text-center',
        className: 'text-center width-sm',
      },
      commonSalary,
      {
        sortableBy: 'localization',
        sortableSide: 'left',
        label: 'Lokalizacja',
        propName: 'localization',
        rowClassName: 'text-center',
        className: 'text-center',
      },
      commonAssignmentUser,
      commonStatus
    )
  else if (project.type === 2)
    headers.push(
      {
        sortableBy: 'date',
        sortableSide: 'right',
        label: 'Termin',
        propName: 'date',
        type: 'date',
        rowClassName: 'text-center',
        className: 'text-center width-sm',
      },
      { label: 'Nr punktu', propName: 'pointNumber', rowClassName: 'text-center', className: 'text-center' },
      { label: 'Długość ', propName: 'duration', rowClassName: 'text-center', className: 'text-center' },
      {
        ...commonSalary,
        label: (
          <AdvancedTooltip
            title=""
            hideIcon
            description="Szacunkowe wynagrodzenie - zależne od rzeczywistej liczby pojazdów"
            sx={{ display: 'inline-flex' }}
            iconColor="primary"
          >
            Wynagrodzenie brutto
          </AdvancedTooltip>
        ),
      },
      commonAssignmentUser,
      {
        sortableBy: 'computedUserResultDate',
        sortableSide: 'left',
        label: 'Rozwiązanie',
        propName: 'computedUserResultDate',
        rowClassName: 'text-center',
        className: 'text-center width-xl',
        type: 'computed',
        fn: (task) => <UserResultDownloadTooltip userFiles={task.userFiles} />,
      },
      commonStatus
    )

  return headers
}
